import React, { useEffect, useState } from "react";

interface StageMetrics {
  label: string;
  count: number;
  percentage: number;
}

interface BarGraphProps {
  graphTitle: string;
  metrics: StageMetrics[];
}

const COLORS = ["#bce3ff", "#e9d5ff", "#ffd6a8"];

const BarGraph: React.FC<BarGraphProps> = ({ graphTitle, metrics }) => {
  const maxCount = Math.max(...metrics.map((data) => data.count));
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div className="p-4 rounded-lg border border-gray-100">
      <div className="flex items-center justify-between mb-8">
        <span className="text-sm font-medium text-gray-900">{graphTitle}</span>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {metrics.map((data, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="h-[180px] w-full bg-gray-50 rounded-xl relative">
              <div
                className="absolute bottom-0 left-0 right-0 transition-all duration-500 ease-out rounded-xl"
                style={{
                  height: show ? `${(data.count / maxCount) * 100}%` : "0%",
                  backgroundColor: COLORS[index % COLORS.length],
                  opacity: 1,
                  transitionDelay: `${index * 100}ms`,
                }}
              />
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-white rounded-lg shadow-sm p-2 w-20 text-center">
                <div className="text-2xl font-semibold text-gray-900">
                  {data.count}
                </div>
                <div className="text-[13px] text-gray-500">
                  {data.percentage}%
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center gap-0.5">
              <div className="text-[13px] font-medium text-gray-900 capitalize mt-2">
                {data.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BarGraph;
